var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "characteristic-scale" }, [
    _vm.title
      ? _c("div", { staticClass: "characteristic-scale--title" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "characteristic-scale--options" }, [
      _c(
        "div",
        [
          _vm._l(_vm.options, function(option, i) {
            return _c(
              "div",
              {
                key: option.key,
                class: [
                  "characteristic-scale--option",
                  {
                    "characteristic-scale--option-selected": _vm.isChecked(
                      option
                    ),
                    "characteristic-scale--option-first": i === 0,
                    "characteristic-scale--option-last":
                      i === _vm.options.length - 1
                  }
                ]
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "characteristic-scale--option-select",
                    on: {
                      mouseenter: function($event) {
                        _vm.hoveredOption = option
                      },
                      mouseleave: function($event) {
                        _vm.hoveredOption = undefined
                      }
                    }
                  },
                  [
                    _c("b-form-radio", {
                      attrs: { value: option.value, name: _vm.name },
                      on: { change: _vm.emitChangeEvent },
                      model: {
                        value: _vm.selected,
                        callback: function($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "characteristic-scale--line" }, [
            _vm._v(" ")
          ])
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.hoveredOption
      ? _c("div", { staticClass: "characteristic-scale--label preview" }, [
          _vm._v(_vm._s(_vm.hoveredLabel))
        ])
      : _c(
          "div",
          {
            class: [
              "characteristic-scale--label",
              { choose: _vm.selected === undefined }
            ]
          },
          [_vm._v(_vm._s(_vm.label))]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }